import { useEffect } from 'react';
import { useRequest } from 'hooks/useRequest';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoaderTwo from './LoaderTwo';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {

	const [request,loading] = useRequest()
	const [staticPage, setStaticPage] = useState()

	const location = useLocation();
	const parsed = location
	useEffect(() => {
		request('/StaticPage/' + parsed?.pathname?.split("/")[2], {
			method: 'GET',
			params: {
				url: parsed?.pathname?.split("/")[2]
			}
		}).then((res) => {
			if (res.data) {
				setStaticPage(res.data.result)
			}
		})

	}, [parsed?.pathname?.split("/")[2]]);

	return (
		<div className='privacyPolicy'>
			<Helmet>
				<title>{staticPage?.metaTitle || staticPage?.title}</title>
                {staticPage?.metaDescription && <meta name='description' content={staticPage?.metaDescription}/>}
			</Helmet>
			
			<LoaderTwo isDataLoading={loading} />
			<div className='privacyPolicy-title'>{staticPage?.title}</div>
			<div className='privacyPolicy-content'>
				<div dangerouslySetInnerHTML={{ __html: staticPage?.content }}></div>
			</div>
		</div>
	)
}

export default PrivacyPolicy
